import React, { Component } from "react";
import styles from "./carInfoData.module.scss";
import SideContentBlock from "../../../shared/sideContentBlock";
import { withUnits } from "../../../shared/containers/containerUnits";
import CmsUnitSettingGrops from "../../Cms/CmsCompany/CmsUnitSettings/CmsUnitSettingGrops";
import UnitInfoData from "./UnitInfoData";
import { withCars } from "../../../shared/containers/containerCars";
import { withAuth } from "../../../shared/containers/containerAuth";
import CmsReprocessUnitPanel from "../../Cms/CmsCompany/CmsReprocessUnitPanel";

class CarInfoData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unitId: null,
      tabIndex: 0,
      tabs: [
        {
          id: 0,
          title: "Информация",
          permission: null,
        },
        {
          id: 1,
          title: "Настройки",
          permission: null,
        },
        {
          id: 2,
          title: "Повторная обработка данных",
          permission: 33001,
        },
      ],
    };
  }

  componentDidUpdate(prevPeops) {
    const { onSelectToChangeUnit, listUnits } = this.props;
    const { unitId } = this.state;
    const id = window.location.pathname.replace("/cars/", "").replace("/settings", "");

    if (unitId !== id && listUnits.length > 0) {
      const unit = listUnits.filter((x) => {
        return x.id === id;
      })[0];

      if (unit !== undefined) {
        onSelectToChangeUnit({
          id: unit.id,
          number: unit.number,
          title: unit.unit.title,
          registerNumber: unit.unit.registerNumber,
          properties: unit.unit.properties,
          inActive: unit.unit.inActive,
        });
        this.setState({ unitId: id });
      }
    }
  }

  setTabIndex(index) {
    this.setState({ tabIndex: index });
  }

  getTabs() {
    const { tabs, tabIndex } = this.state;
    const { data } = this.props;

    return (
      <div className={styles.settingTabsContainer}>
        {tabs
          .filter((x) => {
            return x.permission === null || data.permissions.includes(33001);
          })
          .map((x) => {
            return (
              <div
                key={x.id}
                className={tabIndex === x.id ? styles.settingTabActive : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setTabIndex(x.id);
                }}
              >
                <b>{x.title}</b>
              </div>
            );
          })}
      </div>
    );
  }

  render() {
    const { currentUnit } = this.props;
    const { tabIndex } = this.state;

    if (currentUnit === null) {
      return null;
    }

    return (
      <div className="carIncoData">
        <SideContentBlock>
          {this.getTabs()}
          {tabIndex === 0 ? <UnitInfoData /> : null}
          {tabIndex === 1 ? <CmsUnitSettingGrops /> : null}
          {tabIndex === 2 ? (
            <div style={{ padding: "25px" }}>
              <CmsReprocessUnitPanel unit={currentUnit} />
            </div>
          ) : null}
        </SideContentBlock>
      </div>
    );
  }
}

export default withAuth(withCars(withUnits(React.memo(CarInfoData))));
